import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=8bb7d1c6&scoped=true&"
import script from "./box.ts?vue&type=script&lang=ts&"
export * from "./box.ts?vue&type=script&lang=ts&"
import style0 from "./Box.vue?vue&type=style&index=0&id=8bb7d1c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb7d1c6",
  null
  
)

export default component.exports